import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType } from "@/features/events/types/EventType"
import { FormEvent, useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import PrimaryButton from "../../../components/buttons/PrimaryButton"
import WhiteButtonBlackBorder from "../../../components/buttons/WhiteButtonBlackBorder"
import TextInputElement from "../../../components/input/v1/TextInputElement"
import { createProduct } from "../../../utils/apis/order-service"
import { updateUserInfoWithSwabcode } from "../../../utils/apis/user-service"
import { HOLIFYA_LOGO, PHARMACIES_CONFIRMATION_NUMBER } from "../../../utils/Constants"
import { CreateProductChannel } from "../../../utils/enums/CreateProductChannel"
import { ProductType } from "../../../utils/enums/ProductType"
import { useAuthStore } from "../../../utils/stores/useAuthStore"
import { useUserStore } from "../../../utils/stores/useUserStore"

const PharmaciesRedeemSwabcode = () => {
    const navigate = useNavigate()
    const { sendEvent } = useCreateEvent()
    const { auth } = useAuthStore()
    const idToken = auth.idToken
    const userId = auth.userId
    const { userData } = useUserStore()
    const name = userData.name

    const [isLoading, setIsLoading] = useState(false)
    const [swabcode, setSwabcode] = useState("")
    const [errorText, setErrorText] = useState("")

    const onSubmitClick = async (e: FormEvent) => {
        e.preventDefault()
        await sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "submit_button",
            event_metadata: { action: "swabcode_register", swabcode }
        });
        if (!userId || !idToken) return
        setIsLoading(true)
        updateUserInfoWithSwabcode(
            userId,
            idToken,
            swabcode,
            async () => {
                await sendEvent({
                    event: EventType.SWABCODE_SAVED,
                    sub_category: "pharmacy",
                    event_metadata: { swabcode }
                });
                createProduct(
                    userId,
                    idToken,
                    ProductType.DnaTest,
                    async () => {
                        await sendEvent({
                            event: EventType.PRODUCT_SAVED,
                            sub_category: "pharmacy",
                            event_metadata: { product: ProductType.DnaTest },
                        });
                        navigate("/check-purchases")
                        setIsLoading(false)
                    },
                    async (error) => {
                        await sendEvent({
                            event: EventType.PRODUCT_NOT_SAVED,
                            sub_category: "redeem",
                            event_metadata: { product: ProductType.DnaTest },
                        });
                        console.log(error)
                    },
                    {
                        shopify_product: "one-off",
                        channel: CreateProductChannel.FromPharmacy,
                        code: PHARMACIES_CONFIRMATION_NUMBER,
                        buyer: null,
                        redeemer: null,
                    }
                )
            },
            async (error) => {
                await sendEvent({
                    event: EventType.SWABCODE_NOT_SAVED,
                    sub_category: "pharmacy",
                    event_metadata: { swabcode, error }
                });
                setErrorText(error)
                setIsLoading(false)
            },
        )
    }

    const onSwabCodeInputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setErrorText("")
        setSwabcode(e.target.value)
    }

    const onBackClick = async () => {
        await sendEvent({
            event: EventType.BUTTON_CLICK,
            sub_category: "back_button",
        });
        navigate("/redeem")
    }

    useEffect(() => {
        void sendEvent({
            event: EventType.PAGE_VIEW,
            sub_category: "pharmacy_page",
        })
    }, [])

    // ********************************************************************************

    return (
        <div className="w-full h-screen flex flex-col items-center">
            <div className="w-full h-full flex flex-col items-center justify-end md:justify-center">
                <div className="w-[90%] h-[90%] flex flex-col items-center justify-between md:w-[435px] md:h-[70%]">
                    <div className="flex flex-col items-center">
                        <div className="h-[35px] mb-[10px]">
                            <img src={HOLIFYA_LOGO} alt="Holifya Logo" />
                        </div>
                        <div className="font-normal text-[16px] leading-[24px] text-center mt-[10px]">
                            Ciao {name}, hai acquistato un test del DNA in farmacia.
                        </div>
                    </div>
                    <div className="flex flex-col items-center">
                        <div className="font-bold text-[25px] leading-[33px] mb-[10px]">
                            Inserisci il codice campione
                        </div>
                        <div className="font-normal text-[16px] leading-[24px] text-center mt-[10px]">
                            In farmacia ti hanno dato il codice campione da inserire nella piattaforma. Scrivilo qui sotto e verrai reindirizzato nella tua area personale.
                        </div>
                    </div>
                    <form
                        className="w-full mb-[20px] md:px-[30px]"
                        onSubmit={onSubmitClick}
                    >
                        <div className="h-[85px] mb-[20px]">
                            <TextInputElement
                                label="Codice campione"
                                placeholder="Es: as6TLu53Gvi9"
                                errorText={errorText}
                                inputValue={swabcode}
                                onChange={onSwabCodeInputHandler}
                            />
                        </div>
                        <div className="w-full h-[120px] flex flex-col justify-between">
                            <div className="w-full h-[50px]">
                                <PrimaryButton
                                    text="Conferma codice"
                                    pointer={swabcode.length >= 12}
                                    disabled={swabcode.length < 12}
                                    isLoading={isLoading}
                                />
                            </div>
                            <div className="w-full h-[50px]">
                                <WhiteButtonBlackBorder
                                    text="Indietro"
                                    onClick={onBackClick}
                                    uppercase={false}
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default PharmaciesRedeemSwabcode
